import Page from 'component/page-container'
import { NavLink } from 'react-router-dom'
import Tag from 'component/tag'

import './style.css'

import keysClubBotAvatar from './assets/avatar-keys_club_bot.png'
import processClubBotAvatar from './assets/avatar-process_club_bot.png'
import stickerClubBotAvatar from './assets/avatar-sticker_club_bot.png'
import discountsClubBotAvatar from './assets/avatar-discounts_club_bot.png'
import newsClubBotAvatar from './assets/avatar-news_club_bot.png'
import calendarClubBotAvatar from './assets/avatar-calendar_club_bot.png'
import unwaiterClubBotAvatar from './assets/avatar-unwaiter_club_bot.png'
import recommendationClubBotAvatar from './assets/avatar-recommendation_club_bot.png'


const BotListRoute = props => (
    <Page className="bot-list-page" h1="Боты">
        <div className="page__inner">
            <div className="container">
                <small>
                    <p>Мы любим ботов. Мы постоянно совершенствуем ботов.</p>
                    <p>Большая часть автоматизации клуба происходит через них. Боты управляют аккаунтами, менеджерят календари, синхронизируют процессы, создают стикеры, постят новости в каналы.</p>
                    <p>Вопросы, предложения и идеи новых ботов присылайте Роме Ватриковскому.</p>
                </small>
            </div>

            {/* Хранитель ключей */}
            <div id="keys_club_bot" className="bot-list-page__bot bot">
                <img className="bot__avatar" src={keysClubBotAvatar} alt="Хранитель ключей" />
                <h3 className="bot__title">Хранитель ключей <a className="bot__link" href="https://t.me/keys_club_bot">@keys_club_bot</a></h3>
                <div className="bot__requirements">
                    Работает только в личных диалогах с участниками клуба.
            </div>
                <div className="bot__description">
                    Устанавливает новый пароль от клубного аккаунта.
            </div>
                <div className="bot__command-list">
                    <div className="bot__command command">
                        <code className="command__code">/setpassword</code>
                        <div className="command__caption">Установить новый пароль. Бот будет ждать пароль в следующем сообщении.</div>
                    </div>
                    <div className="bot__command command">
                        <code className="command__code">/cancel</code>
                        <div className="command__caption">Отменяет ожидание нового пароля.</div>
                    </div>
                </div>
            </div>

            {/* Хранитель календаря */}
            <div id="calendar_club_bot" className="bot-list-page__bot bot">
                <img className="bot__avatar" src={calendarClubBotAvatar} alt="Хранитель календаря" />
                <h3 className="bot__title">Хранитель календаря <a className="bot__link" href="https://t.me/calendar_club_bot">@calendar_club_bot</a></h3>
                <div className="bot__requirements">
                    Работает только в клубных чатах, к которым привязан канал. Бот должен быть администратором канала.
            </div>
                <div className="bot__description">
                    <ul>
                        <li>Обновляет клубные календари (у каждого процесса свой календарь, доступный только его участникам);</li>
                        <li>Создает страницы событий на сайте;</li>
                        <li>Постит события в каналы (для комментов);</li>
                    </ul>
                    <div className="bot__command-list">
                        <div className="bot__command command">
                            <code className="command__code">/createevent</code>
                            <div className="command__caption">Присылает в чат шаблон для создания события. Его надо заполнить и запостить в ответ.<br />Потом можно поправить — бот обновит.</div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Хранитель процессов */}
            <div id="process_club_bot" className="bot-list-page__bot bot">
                <img className="bot__avatar" src={processClubBotAvatar} alt="Хранитель процессов" />
                <h3 className="bot__title">Хранитель процессов <a className="bot__link" href="https://t.me/process_club_bot">@process_club_bot</a></h3>
                <div className="bot__requirements">
                    Работает только в чатах.
            </div>
                <div className="bot__description">
                    Регистрирует и обновляет процессы на сайте клуба. Чтобы создать новый процесс, нужно:
                <ul>
                        <li>Создать группу в Телеграме;</li>
                        <li>Сделать ее супергруппой (например, через жопу: переключить в настройках видимость сообщений для новых участников, сохранить и переключить обратно).</li>
                        <li>Создать канал и прилинковать к нему группу (если нужен канал);</li>
                        <li>Добавить в группу Хранителя процессов;</li>
                        <li>Воспользоваться командами:</li>
                    </ul>
                </div>
                <div className="bot__command-list">
                    <div className="bot__command command">
                        <code className="command__code">/createprocess</code>
                        <div className="command__caption">
                            Регистрирует процесс на сайте клуба. Берет название, описание, состав участников и адмминов и прилинкованный канал из информации о чате.
                        Если указать в описании чата тег <Tag>#public</Tag>, процесс будет виден всем. Если не указывать, — только участникам.<br />
                        </div>
                    </div>
                    <div className="bot__command command">
                        <code className="command__code">/updateprocess</code>
                        <div className="command__caption">
                            Обновляет информацию о процессе на сайте клуба.
                    </div>
                    </div>
                </div>
            </div>

            {/* Хранитель стикеров */}
            <div id="sticker_club_bot" className="bot-list-page__bot bot">
                <img className="bot__avatar" src={stickerClubBotAvatar} alt="Хранитель стикеров" />
                <h3 className="bot__title">Хранитель стикеров <a className="bot__link" href="https://t.me/sticker_club_bot">@sticker_club_bot</a></h3>
                <div className="bot__requirements">
                    Работает только в клубных чатах.
            </div>
                <div className="bot__description">
                    <p>Создает текстовые стикеры и добавляет их в стикерпак чата (каждому чату — свой стикерпак).</p>
                    <p>При добавлении нового стикера пак может не обновляться из-за кеша. Лечится перезапуском Телеграма.</p>
                </div>
                <div className="bot__command-list">
                    <div className="bot__command command">
                        <code className="command__code">/addsticker</code>
                        <div className="command__caption">Если ответить этой командой на сообщение, бот создаст из него стикер. Если просто отправить команду, бот будет ждать текст для стикера от отправившего команду.</div>
                    </div>
                    <div className="bot__command command">
                        <code className="command__code">/cancel</code>
                        <div className="command__caption">Отменяет ожидание текста для стикера.</div>
                    </div>
                </div>
            </div>

            {/* Хранитель новостей */}
            <div id="discounts_club_bot" className="bot-list-page__bot bot">
                <img className="bot__avatar" src={newsClubBotAvatar} alt="Хранитель новостей" />
                <h3 className="bot__title">Хранитель новостей <a className="bot__link" href="https://t.me/news_club_bot">@news_club_bot</a></h3>
                <div className="bot__requirements">
                    Работает только в клубных чатах, к которым привязан канал. Бот должен быть администратором канала.
                </div>
                <div className="bot__description">
                    Cобирает сообщения с тегом <Tag>#новость</Tag> и постит утром в соответствующие каналы. Если отредактировать сообщение до публикации новости, бот обновит новость.
                </div>
            </div>

            {/* Хранитель скидок */}
            <div id="discounts_club_bot" className="bot-list-page__bot bot">
                <img className="bot__avatar" src={discountsClubBotAvatar} alt="Хранитель скидок" />
                <h3 className="bot__title">Хранитель скидок <a className="bot__link" href="https://t.me/discounts_club_bot">@discounts_club_bot</a></h3>
                <div className="bot__requirements">
                    Работает в клубных чатах и личных диалогах с участниками.
                </div>
                <div className="bot__description">
                    Собирает сообщения с тегом <Tag>#скидка</Tag> в <NavLink to="/discounts">коллекцию скидок</NavLink>.
                </div>
            </div>

            {/* Хранитель рекомендаций */}
            <div id="recommendation_club_bot" className="bot-list-page__bot bot">
                <img className="bot__avatar" src={recommendationClubBotAvatar} alt="Хранитель рекомендаций" />
                <h3 className="bot__title">Хранитель рекомендаций <a className="bot__link" href="https://t.me/recommendation_club_bot">@recommendation_club_bot</a></h3>
                <div className="bot__requirements">
                    Работает в клубных чатах (лучше в основном, чтобы рекомендации были доступны всем).
                </div>
                <div className="bot__command-list">
                    <div className="bot__command command">
                        <code className="command__code">/addrecommendation</code>
                        <div className="command__caption">Добавляет рекомендацию, следуйте инструкции.</div>
                    </div>
                    <div className="bot__command command">
                        <code className="command__code">/cancel</code>
                        <div className="command__caption">Отменяет создание рекомендации.</div>
                    </div>
                    <div className="bot__command command">
                        <code className="command__code">/like</code>
                        <div className="command__caption">Работает только в комментах к рекомендации. Добавляет/убирает лайк.<br />В списке команд бота отсутствует (иначе тележенька глючит).</div>
                    </div>
                    <div className="bot__command command">
                        <code className="command__code">/visited</code>
                        <div className="command__caption">Работает только в комментах к рекомендации. Добавляет/убирает отметку «просмотрено».<br />В списке команд бота отсутствует (иначе тележенька глючит).</div>
                    </div>
                </div>
            </div>



            {/* Ипшайтег */}
            <div id="unwaiter_club_bot" className="bot-list-page__bot bot">
                <img className="bot__avatar" src={unwaiterClubBotAvatar} alt="Ипшайтег" />
                <h3 className="bot__title">Ипшайтег <a className="bot__link" href="https://t.me/unwaiter_club_bot">@unwaiter_club_bot</a></h3>
                {/* <div className="bot__requirements">
                    Работает в клубных чатах и личных диалогах с участниками.
                </div> */}
                <div className="bot__description">
                    Кидает смешные (иногда) картинки со свалочки: <a target="_blank" rel="noreferrer" href="https://svalko.org">svalko.org</a>. В активные чаты кидает несколько картинок в день сам, без команды.
                </div>
                <div className="bot__command-list">
                    <div className="bot__command command">
                        <code className="command__code">/sendphoto</code>
                        <div className="command__caption">Кидает картинку.</div>
                    </div>
                </div>
            </div>
        </div>
    </Page>
)

export default BotListRoute
